import axios from "axios";

const instance = axios.create();
instance.interceptors.response.use(
  async (response) => {
    if (typeof window !== "undefined" && localStorage.getItem("tokenTime")) {
      const tokenTime = localStorage.getItem("tokenTime");
      const currentTime = new Date().getTime();
      const diff = currentTime - tokenTime;
      const diffInMinutes = Math.floor(diff / 1000 / 60);
      if (diffInMinutes < 1) return response;
    }
    if (
      typeof window !== "undefined" &&
      localStorage.getItem("token") &&
      response.config.headers.Authorization
    ) {
      const getProfileHeader = {
        Authorization: `${localStorage.getItem("token")}`,
        "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
      };
      const res = await axios({
        method: "get",
        url: `${process.env.GATSBY_API_URL}me`,
        headers: getProfileHeader,
      });
    }

    // add X-API-KEY header to all requests
    return response;
  },
  (error) => {
    if (typeof window !== "undefined") {
      if (error.response.status === 401) {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("member");
        window.localStorage.removeItem("mimictoken");
        window.localStorage.removeItem("mimicmember");

        window.location.href =
          process.env.GATSBY_AVIATION_REDIRECT_URL + `members/login`;
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
